(function () {
  function transformToTabs() {
    const section = document.querySelector('[id$="__product_details_D6yiPc"]');
    if (!section) return;

    const accordions = section.querySelector('.accordions');
    if (!accordions) return;

    if (section.querySelector('.product-details-tabs')) return;

    const detailsList = accordions.querySelectorAll(':scope > .accordion > details');
    if (!detailsList.length) return;

    const tabsRoot = document.createElement('div');
    tabsRoot.className = 'product-details-tabs';

    const tabNav = document.createElement('div');
    tabNav.className = 'product-details-tabs__nav';
    tabNav.setAttribute('role', 'tablist');

    const tabPanels = document.createElement('div');
    tabPanels.className = 'product-details-tabs__panels';

    detailsList.forEach((detail, idx) => {
      const summary = detail.querySelector('summary');
      const headingEl = summary && summary.querySelector('.heading');
      const title = (headingEl ? headingEl.textContent : (summary ? summary.textContent : '')).trim() || ('Tab ' + (idx + 1));

      const contentEl = detail.querySelector('.details__content');

      const tab = document.createElement('button');
      tab.type = 'button';
      tab.className = 'product-details-tabs__tab' + (idx === 0 ? ' is-active' : '');
      tab.textContent = title;
      tab.setAttribute('role', 'tab');
      tab.dataset.tabIndex = String(idx);
      tabNav.appendChild(tab);

      const panel = document.createElement('div');
      panel.className = 'product-details-tabs__panel' + (idx === 0 ? ' is-active' : '');
      panel.setAttribute('role', 'tabpanel');
      panel.dataset.tabIndex = String(idx);
      if (contentEl) panel.appendChild(contentEl.cloneNode(true));
      tabPanels.appendChild(panel);
    });

    tabsRoot.appendChild(tabNav);
    tabsRoot.appendChild(tabPanels);

    accordions.style.display = 'none';
    accordions.parentNode.insertBefore(tabsRoot, accordions);

    tabNav.addEventListener('click', function (e) {
      const btn = e.target.closest('.product-details-tabs__tab');
      if (!btn) return;
      const idx = btn.dataset.tabIndex;
      tabNav.querySelectorAll('.product-details-tabs__tab').forEach(function (t) {
        t.classList.toggle('is-active', t.dataset.tabIndex === idx);
      });
      tabPanels.querySelectorAll('.product-details-tabs__panel').forEach(function (p) {
        p.classList.toggle('is-active', p.dataset.tabIndex === idx);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', transformToTabs);
  } else {
    transformToTabs();
  }

  document.addEventListener('shopify:section:load', transformToTabs);
})();
